//
import axios from 'axios'

//
import CustomerModel from '@/models/Sale/SlCustomer'
import { addRUTHyphen, removeRUTHyphen } from '@/services/RUTFormatter'
import CustomerChargeModel from '@/models/Sale/SlCustomerPresetsCharge'
/**
 *
 */
const deleteCustomer = async function(id) {
    //
    try {
        //
        let response = await axios.delete(
            process.env.VUE_APP_API_ROUTE + '/sl_customer/' + id
        )

        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

const fetchAll = async function() {
    try {
        let customers = await CustomerModel.get()
        return customers.data
    } catch (error) {
        return error.response.data
    }
}

const fetchAllAvailableGroundSeller = async function() {
    try {
        let customers = await CustomerModel.append('branch_offices')
            .where('is_available_ground_seller', 1)
            .get()
        return customers.data
    } catch (error) {
        return error.response.data
    }
}

const fetchCustomer = async function(id) {
    try {
        let customer = await CustomerModel.append('branch_offices','discount').include(['sl_customer_presets_charge','g_core_business_sii','main_core_business_sii']).find(id)
        return customer
    } catch (error) {
        return error.response.data
    }
}

const updateCustomer = async function(id, data) {
    //
    try {
        //
        let customer = await fetchCustomer(id)
        //
        customer.rut = addRUTHyphen(data.rut)
        customer.alias_name = data.alias_name
        customer.business_name = data.business_name
        customer.branch_offices = data.branch_offices
        customer.core_business = data.core_business
        customer.discount = data.discount
        customer.email_collection = data.email_collection
        //
        let response = await customer.save()
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

const createCustomer = async function(data) {
    try {
        let customer = new CustomerModel(data)
        let response = await customer.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const createCustomerCharge = async function(data) {
    try {
        let chargeCustomer = new CustomerChargeModel(data)
        let response = await chargeCustomer.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

export default {
    deleteCustomer,
    fetchAll,
    fetchAllAvailableGroundSeller,
    fetchCustomer,
    updateCustomer,
    createCustomer,
    createCustomerCharge,
}
